import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const TestResultsPageStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    "& h4": {
      display: "none"
    },
    "& #read-faq": {
      display: "none"
    },
    "& p": {
      fontSize: "13px"
    },
    padding: "0 20px"
  },
  slideContent: {
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    position: "relative",
    height: "100%",
    marginTop: "50px",
    "& .MuiButton-root": {
      minWidth: "90%"
    }
  },
  bottomContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(3)
  },
  narrowImage: {
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  wideModeContainer: {
    minHeight: "300px",
    maxHeight: "300px",
    height: "300px",
    marginTop: "150px",
    "& .limitHeight": {
      height: "410px"
    }
  },
  wideModeSlidesContainer: {
    height: "440px !important",
    backgroundColor: COLORS.BACKGROUND_BLUE,
    borderRadius: "10px",
    padding: "25px",
    "& [class*='makeStyles-slideContent']": {
      marginTop: "10px"
    }
  }
}));

export default TestResultsPageStyles;
